import { Input } from "antd";
import { RESUME_SECTION_TYPES } from "../../../optimizeResume/editor/config";
import SectionCardShell from "../../../optimizeResume/editor/SectionCardShell";

const FIELDS = [
  { key: "fullName", label: "Full name", placeholder: "Jane Doe" },
  {
    key: "headline",
    label: "Headline / Target role",
    placeholder: "Senior Software Engineer",
  },
  { key: "email", label: "Email", placeholder: "jane@example.com" },
  { key: "phone", label: "Phone", placeholder: "+1 (555) 123-4567" },
  // { key: "addressLine", label: "Address line", placeholder: "200 Congress Ave" },
  { key: "city", label: "City", placeholder: "Austin" },
  { key: "state", label: "State / Province", placeholder: "TX" },
  { key: "country", label: "Country", placeholder: "USA" },
  { key: "postalCode", label: "Postal code", placeholder: "78701" },
  // { key: "dateOfBirth", label: "Date of birth (optional)", placeholder: "1992-04-15" },
  // { key: "nationality", label: "Nationality", placeholder: "Indian" },
  // {
  //   key: "workAuthorization",
  //   label: "Work authorization",
  //   placeholder: "US Citizen / H1-B / OCI / EU Blue Card",
  // },
];

const SOCIAL_LINKS = [
  { type: "linkedin", label: "LinkedIn", placeholder: "https://linkedin.com/in/…" },
  { type: "portfolio", label: "Portfolio", placeholder: "https://…" },
  { type: "github", label: "GitHub", placeholder: "https://github.com/…" },
  { type: "otherLink", label: "Other URL", placeholder: "https://…" },
];

export default function PersonalInfo({ id, data, onChange, onDelete, allCollapsed }) {
  const set = (key, val) => onChange({ ...data, [key]: val });

  const getSocialUrl = (type) =>
    (data?.socialLinks ?? []).find((l) => l.type === type)?.url ?? "";

  const setSocialUrl = (type, val) => {
    const current = data?.socialLinks ?? [];
    const idx = current.findIndex((l) => l.type === type);
    let next;
    if (val) {
      if (idx >= 0) {
        next = current.map((l, i) => (i === idx ? { ...l, url: val } : l));
      } else {
        next = [...current, { type, url: val }];
      }
    } else {
      next = current.filter((l) => l.type !== type);
    }
    onChange({ ...data, socialLinks: next });
  };

  return (
    <SectionCardShell
      id={id}
      type={RESUME_SECTION_TYPES.PERSONAL_INFO}
      data={data}
      onChange={onChange}
      onDelete={onDelete}
      allCollapsed={allCollapsed}
    >
      <div className="grid grid-cols-2 gap-3">
        {FIELDS.map(({ key, label, placeholder }) => (
          <label key={key} className="flex flex-col gap-1 text-sm text-[#475467]">
            <span>{label}</span>
            <Input
              value={data?.[key] ?? ""}
              onChange={(e) => set(key, e.target.value)}
              placeholder={placeholder}
            />
          </label>
        ))}
        {SOCIAL_LINKS.map(({ type, label, placeholder }) => (
          <label key={type} className="flex flex-col gap-1 text-sm text-[#475467]">
            <span>{label}</span>
            <Input
              value={getSocialUrl(type)}
              onChange={(e) => setSocialUrl(type, e.target.value)}
              placeholder={placeholder}
            />
          </label>
        ))}
      </div>
    </SectionCardShell>
  );
}
